import { render, staticRenderFns } from "./InviteContactModal.vue?vue&type=template&id=55cdaf7f&"
import script from "./InviteContactModal.vue?vue&type=script&lang=js&"
export * from "./InviteContactModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteContactModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55cdaf7f')) {
      api.createRecord('55cdaf7f', component.options)
    } else {
      api.reload('55cdaf7f', component.options)
    }
    module.hot.accept("./InviteContactModal.vue?vue&type=template&id=55cdaf7f&", function () {
      api.rerender('55cdaf7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/hotb/InviteContactModal.vue"
export default component.exports